import { CommonModule } from '@angular/common';
import { Component,Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyDialogModule, MatLegacyDialogRef, MAT_LEGACY_DIALOG_DATA, MatLegacyDialogConfig } from '@angular/material/legacy-dialog';
import { MatLegacyRadioModule } from '@angular/material/legacy-radio';
import { AppButtonModule } from '../../../../dave-utils-module/app-button-module/app-button.module';
import { CustomLabelService } from '../../../../services/custom-label/custom-label.service';
import { appMatDialogDefaultConfig } from '../../../../helper/helper';

export interface NewOrderConfirmDialogData {
    supplierName: string | null;
    commissionName: string | null;
    documentTypeName: string;
}
export enum NewOrderConfirmDialogPriceType {
    costFromM2s = 'cost-from-m2s',
    costFromArl = 'cost-from-arl',
}
export type NewOrderConfirmDialogReturnData = undefined | NewOrderConfirmDialogPriceType;
@Component({
    selector: 'app-new-order-confirm-dialog',
    standalone: true,
    imports: [CommonModule, MatLegacyDialogModule, MatLegacyRadioModule, FormsModule, AppButtonModule],
    templateUrl: './new-order-confirm-dialog.component.html',
    styleUrls: ['./new-order-confirm-dialog.component.scss'],
})
export class NewOrderConfirmDialogComponent {
    public static readonly DefaultConfig: MatLegacyDialogConfig = {
        ...appMatDialogDefaultConfig,
    };
    protected supplierName: string = '';
    protected documentTypeName: string = '';
    protected supplierLabel$: Observable<string> = this.cls.getSingle$('Supplier');
    protected commissionName: string = '';
    protected commissionLabel$: Observable<string> = this.cls.getSingle$('Commission');
    protected priceType: NewOrderConfirmDialogPriceType = NewOrderConfirmDialogPriceType.costFromArl;
    protected readonly NewOrderConfirmDialogPriceType = NewOrderConfirmDialogPriceType;
    constructor(
        @Inject(MAT_LEGACY_DIALOG_DATA) data: NewOrderConfirmDialogData,
        public dialogRef: MatLegacyDialogRef<NewOrderConfirmDialogComponent, NewOrderConfirmDialogReturnData>,
        protected cls: CustomLabelService
    ) {
        if (data) {
            this.supplierName = data.supplierName;
            this.documentTypeName = data.documentTypeName;
            this.commissionName = data.commissionName;
        }
    }
}
